/**
 * @module perceptive-html
 * TODO config beacon-leave off => disable scrollTo/jumps, weniger beacons
 * TODO config beacon-enter off => force hardLimit for initial claim, useless centerer
 * TODO mit hardLimit adaptivePolicy deaktivieren?
 * TODO optimize beacons in disableSuspend
 * TODO CONSTRUCT RATE LIMIT!
 * TODO PULL RATE LIMIT!
 * TODO index modulo custom property?
 * TODO  anstatt MIN_LENGTH können die css properties verwendet werden.
 *
 * TODO Worker-Command Scheme
 * Rückgabewert soll eine Command-Function sein!
 * So können auch die Observer (Worker) in eigene Module
 * Für den Warpdrive
 * type WarpdriveCommand = (enable: boolean, initialData?: T[]) => void
 * Für den ConstructionWorker (creator)
 * type ConstructionCommand = (active: boolean, stubs: Stub[], considerSoftLimit: () => {}, limiter, policyStep, limit, enableSuspend, stubsWithLoader, cancelOrDestruct: (stub, loader) => {}) => void, claim: (number) => Promise, observeBeacons())
 */
// prettier-ignore
import { window, addClass, removeClass, append, HTMLElement, setStyle, setTimeout, clearTimeout, pushToArray, createMap, putOnMap, getFromMap, deleteFromMap, clearArray, sizeOfArray, sliceOfArray, forEachOfArray, shiftArray, max, min, remove, abs, ceil, round, onWindow, on, off, prepend, requestIdleCallback, cancelIdleCallback, observeSize, disconnect, observe, unobserve, observeIntersection, matches, createElement, getComputedStyleValue, popArray, unshiftArray, scrollingElement, existsOnMap, parentElement, clearMap, getValuesOfMap, getKeysOfMap, floor, sizeOfMap, spliceArray, removeChildNodes } from "@acng/frontend-bounty";
import { createMutex } from "@acng/frontend-bounty/mutex";
const moduleName = 'perceptive-html';
// private stub properties
const indexSymbol = Symbol();
const dataSymbol = Symbol();
const waitSymbol = Symbol();
export const scrollTo_ = Symbol();
// css classnames for debug purposes
const CSS_DEBUG_BEACON = "warp-beacon";
const CSS_DEBUG_CENTER = "warp-center";
const MIN_LENGTH = 10;
const POPSTATE_EVENT = "popstate";
const BEACON_RATE = 2;
const PRESET_POLICY_ROW = ".warp-row-inset,.warp-row-flex";
const PRESET_POLICY_COLUMN = ".warp-column-inset,.warp-column-flex";
const PRESET_POLICY_GRID = ".warp-grid";
const PRESET_SOFTLIMIT = ".warp-grid.warp-row-limit";
const PRESET_INSET = ".warp-row-inset,.warp-column-inset";
const PRESET_INSET_GRID = ".warp-grid-inset";
const PRESET_SUSPEND = ".warp-grid,.warp-row-inset,.warp-column-inset";
const PROPERTY_LIMIT = "--warp-limit";
const PROPERTY_INDEX = "--i";
const PROPERTY_TAGNAME = "--warp-stub-name";
const DEFAULT_TAGNAME = "article";
const POLICY_LIMIT_INFO = 30;
const POLICY_LIMIT_WARN = 50;
const POLICY_LIMIT_FAIL = 100;
export function createPerceptiveHTML(element, stream, construct, destructArg) {
    const destruct = destructArg ?? (() => { });
    let softLimit = Infinity;
    let dataLimit = Infinity; // TODO check this
    let hardLimit = Infinity;
    let visible = false;
    let policyCountPrevious = 0;
    let policyStep = 0;
    let policyPreload = 0;
    let policyUnload = 0;
    let active = false;
    let centerTile;
    let probeTime;
    let probeTimeout;
    let previousScrollTarget;
    let sniffer;
    let considerSoftLimit = false;
    let logName;
    let historyKey;
    /**
     * Part of the Quickfix for ACNG-8465:
     * Once connected scroll the root.previousSibling into view when no beacon is intersecting.
     */
    let ensuredScrollPosition = false;
    const limit = () => min(softLimit, hardLimit, dataLimit);
    const history = window.history; // TODO add bounty or use context / scroll-control
    let enableHistory = false; //config.history ?? false; // TODO enable history somehow / scroll-control
    let enableCenterProbe = enableHistory;
    const stubs = [];
    const stubsWithLoader = new Map();
    const root = (() => {
        if (element instanceof HTMLElement) {
            if (matches(element, PRESET_SOFTLIMIT)) {
                considerSoftLimit = true;
            }
            return element;
        }
        DEBUG: if (logName) {
            console.error(`${logName} - rootBox - %O must be instanceof %O.`, element, HTMLElement);
        }
        throw Error(`${logName} illegal root`);
    })();
    const stubTagName = getComputedStyleValue(root, PROPERTY_TAGNAME) || DEFAULT_TAGNAME;
    const policyCount = matches(root, PRESET_POLICY_ROW)
        ? () => scrollWidth / sniffWidth
        : matches(root, PRESET_POLICY_COLUMN)
            ? () => scrollHeight / sniffHeight
            : matches(root, PRESET_POLICY_GRID)
                ? () => (rootWidth * scrollHeight) / sniffWidth / sniffHeight
                : () => scrollHeight / sniffHeight;
    const enableStyleIndex = matches(root, PRESET_INSET);
    const enableSuspend = matches(root, PRESET_SUSPEND);
    const enableStyleGrid = matches(root, PRESET_INSET_GRID);
    const scrollBox = (() => {
        let current;
        for (current = root; current; current = parentElement(current)) {
            if (getComputedStyleValue(current, "overflow") !== "visible") {
                break;
            }
        }
        if (!current) {
            current = scrollingElement;
        }
        if (!current) {
            throw Error("no scrolling element");
        }
        return current;
    })();
    const scrollEvent = "onscrollend" in scrollBox ? "scrollend" : "scroll";
    const minWidth = parseInt(getComputedStyleValue(root, "--warp-min-width")) || MIN_LENGTH;
    /**
     * Display data
     * TODO consider setting policy here
     * TODO consider start with hardLimit = 0
     * TODO consider pending claim/pull
     * TODO consider return promise
     */
    const connect = () => {
        // it is necessary to reobserve stuff in the end, for the active without beacons case
        // so we simply
        stop();
        // setup
        dataLimit = Infinity;
        hardLimit = parseInt(getComputedStyleValue(root, PROPERTY_LIMIT)) || Infinity;
        // Replace dataqueue.
        const dataQueue = stream.queue;
        // Cache legacy data.
        const dataMap = createMap();
        const legacyLimit = min(limit(), sizeOfArray(stubs));
        forEachOfArray(stubs, (stub) => putOnMap(dataMap, stub[dataSymbol], stub));
        DEBUG: if (logName) {
            const legacyStubs = stubs.map(v => v[dataSymbol]);
            console.debug(`${logName} connect`, { root, scrollBox, hardLimit, dataQueue: [...dataQueue], legacy: [...dataMap.entries()], legacyStubs, legacyLimit });
        }
        // Clear current index.
        clearArray(stubs);
        // Keep reusable stubs and create new ones according to the new dataQueue
        if (enableStyleIndex || enableStyleGrid) {
            for (let index = 0; index < legacyLimit; index++) {
                const data = shiftArray(dataQueue);
                if (!data) {
                    break;
                }
                const legacyStub = getFromMap(dataMap, data);
                if (legacyStub) {
                    deleteFromMap(dataMap, data);
                    legacyStub[indexSymbol] = index;
                    if (enableStyleIndex) {
                        setStyle(legacyStub, PROPERTY_INDEX, `${index}`);
                    }
                    if (enableStyleGrid) {
                        styleInset(legacyStub);
                    }
                    pushToArray(stubs, legacyStub);
                }
                else {
                    addStub(data);
                }
            }
        }
        // Remove old stubs which where not in the new dataQueue so far.
        for (const stub of getValuesOfMap(dataMap)) {
            const loader = getFromMap(stubsWithLoader, stub);
            if (loader) {
                DEBUG: if (logName)
                    console.debug(`${logName} remove old stub with loader`, { stub, loader });
                deleteFromMap(stubsWithLoader, stub);
                cancelOrDestruct(stub, loader);
            }
            else {
                DEBUG: if (logName)
                    console.debug(`${logName} remove old stub WITHOUT loader`, stub);
            }
            remove(stub);
        }
        ensuredScrollPosition = false;
        enable();
    };
    const enable = () => {
        DEBUG: if (logName)
            console.assert(!sniffer, `${logName} sniffer is still there!`);
        // establish sniffer when there is no policy yet.
        observe(arbiter, scrollBox);
        observe(arbiter, root);
        if (!sniffWidth || !sniffHeight) {
            sniffer = createElement(stubTagName);
            DEBUG: if (logName) {
                addClass(sniffer, "sniffer");
                console.debug(`${logName} enable with sniffer`, { sniffer });
            }
            if (enableStyleIndex) {
                setStyle(sniffer, PROPERTY_INDEX, "0");
            }
            if (enableStyleGrid) {
                setStyle(sniffer, "--warp-col", "0");
                setStyle(sniffer, "--warp-row", "0");
                setStyle(sniffer, "--warp-height", `${MIN_LENGTH * 2}px`);
                setStyle(sniffer, "--warp-width", `${MIN_LENGTH * 2}px`);
            }
            prepend(root, sniffer);
            observe(arbiter, sniffer);
        }
        DEBUG: if (logName)
            console.debug(`${logName} enable`, { scrollBox, root, sniffer });
    };
    let sniffWidth = 0;
    let sniffHeight = 0;
    let scrollWidth = 0;
    let scrollHeight = 0;
    let rootWidth = 0;
    let rootHeight = 0;
    let policyLimit = 0;
    /**
     * Activated in connect
     * Deactivated in stop
     */
    const arbiter = observeSize((entries) => {
        let force = false;
        let sniffCount = 0;
        let sniffWidthSum = 0;
        let sniffHeightSum = 0;
        const cutoffStubs = [];
        for (const entry of entries) {
            const target = entry.target;
            const { width, height } = entry.contentRect;
            if (target === root) {
                DEBUG: if (logName)
                    console.debug(`${logName} arbiter`, { root, width, height });
                rootWidth = width;
                rootHeight = height;
                visible = width > MIN_LENGTH || height > MIN_LENGTH;
                if (visible && !active) {
                    active = force = true;
                    if (enableHistory) {
                        onpopstate();
                        onWindow(POPSTATE_EVENT, onpopstate);
                    }
                    if (enableCenterProbe) {
                        on(scrollBox, scrollEvent, probe, { passive: true });
                    }
                    DEBUG: if (logName)
                        console.debug(`${logName} arbiter force reset`);
                    observe(disabler, root);
                }
                if (!visible) {
                    return;
                }
                // root and scrollBox could be the same. In that case the scrollBox handling must not be skipped.
                if (root !== scrollBox) {
                    // if only root has the change do nothing more. This is the case when stubs are added.
                    if (sizeOfArray(entries) === 1 && !force) {
                        return;
                    }
                    continue;
                }
                else {
                    DEBUG: if (logName)
                        console.info(`${logName} root == scrollBox`);
                }
            }
            if (target === scrollBox) {
                DEBUG: if (logName)
                    console.debug(`${logName} arbiter`, { scrollBox, width, height });
                scrollWidth = width;
                scrollHeight = height;
                if (enableCenterProbe && centerTile) {
                    // TODO check this
                    DEBUG: if (logName)
                        console.debug(`${logName} - arbiter - center at index ${centerTile[indexSymbol]}`);
                    centerTile.scrollIntoView({ behavior: "instant", block: "center", inline: "center" });
                }
                continue;
            }
            if (width >= MIN_LENGTH && height >= MIN_LENGTH) {
                sniffCount++;
                sniffWidthSum += width;
                sniffHeightSum += height;
            }
            DEBUG: if (logName)
                console.debug(`${logName} arbiter`, { target, sniffer, width, height });
            if (target == sniffer) {
                continue;
            }
            if (width < MIN_LENGTH || height < MIN_LENGTH) {
                unshiftArray(cutoffStubs, target);
            }
        }
        if (sniffCount) {
            if (sniffer) {
                DEBUG: if (logName)
                    console.debug(`${logName} remove sniffer`);
                unobserve(arbiter, sniffer);
                remove(sniffer);
                sniffer = null;
            }
            // TODO improve averaging tile dimensions
            sniffWidth = sniffWidthSum / sniffCount;
            sniffHeight = sniffHeightSum / sniffCount;
            DEBUG: if (logName)
                console.debug(`${logName} sniff`, { sniffWidth, sniffHeight, sniffCount });
        }
        if (!active) {
            return;
        }
        // As long as everything is checked every time, the softLimit can be reset.
        softLimit = Infinity;
        const count = max(2, policyCount());
        if (sizeOfArray(cutoffStubs)) {
            considerSoftLimit = true;
            ASSERT: {
                let index = stubs.length;
                for (const stub of cutoffStubs) {
                    console.assert(stub[indexSymbol] == --index, `${logName} limiter cutoff is no seamless tail`, {
                        stub,
                    });
                }
            }
            forEachOfArray(cutoffStubs, (stub) => {
                const index = stub[indexSymbol];
                stream.unget([stub[dataSymbol]]);
                //unshiftArray(dataQueue, stub[dataSymbol]);
                // TODO ? Optimize REMOVE by not reobserving every time
                REMOVE(stub);
                // TODO consider softLimit == 0
                softLimit = min(index, softLimit);
                DEBUG: if (logName)
                    console.debug(`${logName} limiter`, { index, softLimit });
            });
        }
        if (enableStyleGrid) {
            const cols = floor(rootWidth / minWidth);
            setStyle(root, "--warp-width", `${rootWidth / cols}px`);
            setStyle(root, "--warp-height", `${rootWidth / cols}px`);
            for (const stub of getKeysOfMap(stubsWithLoader)) {
                styleInset(stub);
            }
        }
        if (force || abs(count - policyCountPrevious) > 1) {
            if (count >= POLICY_LIMIT_INFO || count <= 0) {
                // TODO improve me
                if (count >= POLICY_LIMIT_FAIL || count <= 0) {
                    if (enableSuspend) {
                        console.error(`${logName} policy limit ${count}`, {
                            rootWidth,
                            rootHeight,
                            sniffWidth,
                            sniffHeight,
                        });
                        return; //TODO this breaks infinityClaim
                    }
                }
                else if (count >= POLICY_LIMIT_WARN) {
                    DEBUG: if (logName)
                        console.warn(`${logName} policy limit ${count}`);
                }
                else {
                    DEBUG: if (logName)
                        console.info(`${logName} policy limit ${count}`);
                }
            }
            if (policyStep) {
                // TODO check if this is happening
                if (count == Infinity && !force) {
                    DEBUG: if (logName)
                        console.warn(`${logName} arbiter skipped - waiting for infinityClaim`);
                    return;
                }
                disconnectBeacons();
            }
            policyCountPrevious = count;
            policyStep = ceil(count / BEACON_RATE);
            const policyBuffer = ceil(count / 2);
            policyPreload = 1 * policyStep + policyBuffer; // mindestens eine zeile damit niemals lücken kommen, idealer zwei zeilen
            policyUnload = (BEACON_RATE + 1) * policyStep + policyBuffer;
            policyLimit = 6 * policyUnload;
            ASSERT: console.assert(policyPreload >= policyStep, "policyStep cannot be larger than policyPreload!");
            DEBUG: if (logName)
                console.debug(`${logName} adaptive policy`, {
                    policyCountPrevious,
                    policyStep,
                    policyPreload,
                    policyUnload,
                    policyLimit,
                    softLimit,
                });
            claim(min(limit(), policyPreload)).then(() => {
                const stubCount = sizeOfArray(stubs);
                DEBUG: if (logName && !stubCount) {
                    console.info(`${logName} is empty`);
                }
                // In softLimit observe all, otherwhise observe only a few
                for (let i = 0; i < (considerSoftLimit ? stubCount : min(stubCount, policyStep)); i++) {
                    observe(arbiter, stubs[i]);
                }
                observeBeacons();
            });
        }
    });
    const styleInset = (stub) => {
        const index = stub[indexSymbol];
        const cols = floor(rootWidth / minWidth);
        setStyle(stub, "--warp-col", `${index % cols}`);
        setStyle(stub, "--warp-row", `${floor(index / cols)}`);
        if (index == sizeOfArray(stubs) - 1) {
            setStyle(root, "height", `${(ceil(sizeOfArray(stubs) / cols) * rootWidth) / cols}px`);
        }
    };
    const disabler = observeSize((entries) => {
        const { width, height } = entries[0].contentRect;
        if (width < MIN_LENGTH && height < MIN_LENGTH) {
            stop();
            // restart arbiter
            DEBUG: if (logName)
                console.debug(`${logName} hibernate`);
            centerTile = null; // TODO check this
            // Destruct all loaders.
            for (const [stub, loader] of stubsWithLoader) {
                cancelOrDestruct(stub, loader);
            }
            clearMap(stubsWithLoader);
            // Remove all stubs.
            let stub;
            while ((stub = popArray(stubs))) {
                remove(stub);
                stream.unget([stub[dataSymbol]]);
            }
            enable();
        }
    });
    const stop = () => {
        active = false;
        if (sniffer) {
            remove(sniffer);
            sniffer = null;
        }
        DEBUG: if (logName)
            console.debug(`${logName} stop`);
        for (const observer of [arbiter, disabler, creator, centerer]) {
            disconnect(observer);
        }
        // Remove eventlisteners.
        off(window, POPSTATE_EVENT, onpopstate);
        off(scrollBox, scrollEvent, probe);
    };
    const creator = observeIntersection((entries) => {
        ASSERT: console.assert(active, `${logName} creator runs while warpdrive sleeps!`);
        const stubCount = sizeOfArray(stubs);
        let firstClaimIndex = stubCount;
        let head = stubCount;
        let tail = 0;
        let umountHead = stubCount;
        let umountTail = 0;
        let topSum = 0;
        let bottomSum = 0;
        let recentTime = 0;
        DEBUG: if (logName)
            console.debug(`${logName} creator`, {
                policyStep,
                policyPreload,
                policyUnload,
                policyLimit,
                load: sizeOfMap(stubsWithLoader),
            });
        for (const { target, boundingClientRect: { width, height }, time, isIntersecting, } of entries) {
            if (width < MIN_LENGTH || height < MIN_LENGTH) {
                DEBUG: if (logName)
                    console.warn(`${logName} beacon - tiny stub detected - start limiter and break`, {
                        index: target[indexSymbol],
                        data: target[dataSymbol],
                        target,
                    });
                considerSoftLimit = true;
                stop();
                enable();
                return;
            }
            if (isIntersecting) {
                recentTime = max(recentTime, time);
            }
        }
        for (const { rootBounds, boundingClientRect, target, isIntersecting, time } of entries) {
            if (!rootBounds) {
                DEBUG: console.error(`${logName} creator - beacon is outside of scrollBox`, { target });
                continue;
            }
            if (!isIntersecting || time < recentTime) {
                continue;
            }
            const index = target[indexSymbol];
            const overTop = boundingClientRect.top < rootBounds.top || boundingClientRect.left < rootBounds.left;
            const underBottom = boundingClientRect.bottom > rootBounds.bottom || boundingClientRect.right > rootBounds.right;
            // TODO check these ranges
            const headOffset = overTop ? policyPreload : policyUnload;
            const tailOffset = underBottom ? policyPreload : policyUnload;
            topSum += headOffset;
            bottomSum += tailOffset;
            head = min(head, max(0, index - headOffset));
            tail = max(tail, min(limit(), 1 + index + tailOffset));
            umountHead = min(umountHead, max(0, index - policyUnload));
            umountTail = max(umountTail, min(limit(), 1 + index + policyUnload));
            firstClaimIndex = min(firstClaimIndex, index);
            DEBUG: if (logName)
                console.debug(`${logName} beacon enter`, { index, head, tail, load: sizeOfMap(stubsWithLoader) });
            if (!enableSuspend) {
                DEBUG: removeClass(target, CSS_DEBUG_BEACON);
                unobserve(creator, target); // TODO improve this
            }
        }
        if (head == stubCount && tail == 0) {
            // No beacon is intersecting
            if (enableHistory && !ensuredScrollPosition) {
                // This is part of the Quickfix for ACNG-8465
                DEBUG: console.warn(`${logName} creator - no beacon intersecting - try to scroll into view`);
                root.parentElement?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
                ensuredScrollPosition = true;
            }
            return;
        }
        ensuredScrollPosition = true;
        if (enableSuspend && (umountHead > 0 || umountTail < stubCount)) {
            for (const [stub, loader] of stubsWithLoader) {
                const index = stub[indexSymbol];
                if (index < umountHead || index >= umountTail) {
                    DEBUG: if (logName)
                        console.debug(`${logName} clear stub`, { index, stub });
                    removeChildNodes(stub);
                    deleteFromMap(stubsWithLoader, stub);
                    cancelOrDestruct(stub, loader);
                }
            }
        }
        let u = head;
        let v = min(stubCount, tail) - 1;
        let d = 1;
        if (bottomSum > topSum) {
            u = v;
            v = head;
            d = -1;
        }
        DEBUG: if (logName)
            console.debug(`${logName} creator iterate`, { u, v, d, topSum, bottomSum });
        for (let i = u; d > 0 ? i <= v : i >= v; i += d) {
            mount(stubs[i]);
        }
        if (stubCount < tail) {
            DEBUG: if (logName)
                console.info(`${logName} claim at beacon`, { tail });
            claim(tail).then(() => {
                disconnectBeacons(firstClaimIndex);
                observeBeacons(firstClaimIndex);
            });
        }
    }, { root: scrollBox });
    const cancelOrDestruct = (stub, loader) => {
        if (stub[waitSymbol]) {
            DEBUG: if (logName)
                console.debug(`${logName} cancel loader #${stub[indexSymbol]}`);
            cancelIdleCallback(stub[waitSymbol]);
            delete stub[waitSymbol];
        }
        else {
            loader.target = null;
            loader.template.then(() => destruct(loader)).catch((reason) => {
                DEBUG: if (logName)
                    console.warn(`${logName} loader at #${stub[indexSymbol]} was rejected for reason`, { reason });
            });
        }
    };
    const claimMutex = createMutex(false, logName);
    /**
     * Claim stubs, respect queue exchange by not adding stubs but return immediately
     * Strict serial
     * TODO rethink infinityClaim, maybe be use configurable hardlimit or detect double infinity
     */
    const claim = async (claimCount) => {
        if (claimCount <= sizeOfArray(stubs)) {
            return;
        }
        const localStream = stream.queue;
        await claimMutex(async () => {
            const stubCount = sizeOfArray(stubs);
            DEBUG: if (logName)
                console.info(`${logName} claim for ${claimCount} stubs (${claimCount - stubCount} additional)`, {
                    realcount: sizeOfArray(stubs),
                });
            const stubQueue = await stream.get(stubCount, claimCount);
            // TODO call abort as soon as stream changes
            if (localStream !== stream.queue) {
                throw Error('stream changed');
                //return;
            }
            dataLimit = stream.limit;
            if (!active) {
                DEBUG: if (logName)
                    console.warn(`${logName} claim - inactive now or stream changed- push data back into queue`);
                stream.unget(stubQueue);
            }
            else {
                DEBUG: if (logName)
                    console.debug(`${logName} adding ${sizeOfArray(stubQueue)} stubs`);
                forEachOfArray(stubQueue, addStub);
                // TODO this may be too much, optimize
                if (!enableSuspend) {
                    DEBUG: if (logName)
                        console.warn(`${logName} wait for all stubs`);
                    await Promise.all(sliceOfArray(stubs, stubCount).map((stub) => (mount(stub), getFromMap(stubsWithLoader, stub)?.template)));
                }
            }
        });
    };
    const addStub = (data) => {
        const stub = createElement(stubTagName);
        const index = pushToArray(stubs, stub) - 1;
        DEBUG: if (logName)
            console.debug(`${logName} addStub`, { index, data });
        stub[indexSymbol] = index;
        stub[dataSymbol] = data;
        if (enableStyleIndex) {
            setStyle(stub, PROPERTY_INDEX, `${index}`);
        }
        if (enableStyleGrid) {
            styleInset(stub);
        }
        append(root, stub);
    };
    /**
     * TODO use template from config for element and maybe use onload and onerror
     */
    const mount = (stub) => {
        if (existsOnMap(stubsWithLoader, stub)) {
            return;
        }
        DEBUG: if (logName)
            console.info(`${logName} mount`, {
                index: stub[indexSymbol],
                stub,
                load: sizeOfMap(stubsWithLoader),
            });
        const loader = {
            target: stub,
            template: new Promise((resolve) => {
                const mounter = () => {
                    delete stub[waitSymbol];
                    construct(stub[dataSymbol], loader)
                        .then(template => {
                        DEBUG: if (logName)
                            console.info(`${logName} constructed`, { data: stub[dataSymbol], template, target: loader.target });
                        if (template && loader.target) {
                            addClass(loader.target, ...template.classList);
                            append(loader.target, template.content);
                        }
                        resolve(template);
                    })
                        .catch((reason) => {
                        if (logName)
                            console.info(`${logName} remove for reason`, reason);
                        if (loader.target) {
                            REMOVE(stub);
                            resolve(undefined);
                        }
                    });
                };
                // TODO
                if (!enableSuspend || sizeOfMap(stubsWithLoader) < policyLimit) {
                    stub[waitSymbol] = requestIdleCallback(mounter); // TODO may be requestAnimationFrame
                }
                else {
                    console.error(`${logName} policy limit reached`, { policyLimit });
                    stop();
                    throw Error("bla");
                }
            }),
        };
        putOnMap(stubsWithLoader, stub, loader);
    };
    /**
     * Wird aufgerufen wenn
     * - ein construct fehlschlägt
     * - ein element zu klein ist
     */
    const REMOVE = (stub) => {
        DEBUG: if (logName)
            console.info(`${logName} remove`, { index: stub[indexSymbol], data: stub[dataSymbol], stub });
        const index = stub[indexSymbol];
        unobserve(centerer, stub);
        unobserve(arbiter, stub);
        disconnectBeacons(index);
        spliceArray(stubs, index, 1);
        const stubCount = sizeOfArray(stubs);
        for (let i = index; i < stubCount; i++) {
            stubs[i][indexSymbol] = i;
            if (enableStyleIndex) {
                setStyle(stubs[i], PROPERTY_INDEX, `${i}`);
            }
            if (enableStyleGrid) {
                styleInset(stubs[i]);
            }
        }
        const loader = getFromMap(stubsWithLoader, stub);
        if (loader) {
            deleteFromMap(stubsWithLoader, stub);
            cancelOrDestruct(stub, loader);
        }
        remove(stub);
        dataLimit--; // TODO wenn das ein softlimit remove ist soll er das nicht tun, das haut nämlich nur hin wenn dataLimit == Infinity
        observeBeacons(index); // TODO was wenn keine mehr da sind? derzeit krepiert der warpdrive
    };
    // TODO improve condition after first scroll event?
    const centerer = observeIntersection((entries) => {
        disconnect(centerer);
        let sumIndex = 0.0;
        let weight = 0.0;
        for (const { target, intersectionRatio } of entries) {
            const index = target[indexSymbol];
            DEBUG: if (logName)
                console.debug({ index, target, intersectionRatio });
            ASSERT: console.assert(target === stubs[index], `index ${index} is not consistent`);
            sumIndex += intersectionRatio * index;
            weight += intersectionRatio;
        }
        const centerIndex = round(sumIndex / weight);
        if (enableCenterProbe && (!centerTile || centerTile[indexSymbol] !== centerIndex)) {
            DEBUG: centerTile?.classList.remove(CSS_DEBUG_CENTER);
            if (centerIndex) {
                centerTile = stubs[centerIndex];
                ASSERT: console.assert(!!centerTile, "calculated centerTile not found");
                DEBUG: if (logName)
                    centerTile?.classList.add(CSS_DEBUG_CENTER);
            }
            if (enableHistory) { // TODO scroll-control
                const state = history.state || {};
                state[historyKey] = centerIndex;
                DEBUG: if (logName)
                    console.info(`history.replaceState(%O)`, state);
                history.replaceState(state, "");
            }
        }
        DEBUG: if (logName)
            console.info(`${logName} centered at`, { centerIndex });
    }, { root: scrollBox });
    const disconnectBeacons = (firstIndex = 0) => {
        firstIndex -= firstIndex % policyStep;
        DEBUG: if (logName)
            console.debug(`${logName} disconnectBeacons`, { firstIndex, policyStep });
        const stubCount = sizeOfArray(stubs);
        for (let i = firstIndex; i < stubCount; i += policyStep) {
            unobserve(creator, stubs[i]);
            DEBUG: removeClass(stubs[i], CSS_DEBUG_BEACON);
        }
    };
    const observeBeacons = (firstIndex = 0) => {
        firstIndex -= firstIndex % policyStep;
        DEBUG: if (logName)
            console.debug(`${logName} observeBeacons`, { firstIndex, policyStep });
        const stubCount = sizeOfArray(stubs);
        for (let i = firstIndex; i < stubCount; i += policyStep) {
            observe(creator, stubs[i]);
            DEBUG: addClass(stubs[i], CSS_DEBUG_BEACON);
        }
    };
    const probe = async () => {
        await claimMutex((async () => { }));
        const timeElapsed = Date.now() - probeTime;
        const probeThrottleTime = 1000;
        if (probeTimeout) {
            clearTimeout(probeTimeout);
            probeTimeout = 0;
        }
        if (timeElapsed < probeThrottleTime) {
            probeTimeout = setTimeout(probe, probeThrottleTime - timeElapsed);
            return;
        }
        DEBUG: if (logName)
            console.debug(`${logName} start center probe`, { refreshAfter: `${Date.now() - probeTime} ms` });
        probeTime = Date.now();
        probeTimeout = 0;
        for (const stub of getKeysOfMap(stubsWithLoader)) {
            observe(centerer, stub);
        }
    };
    const scrollTo = async (index) => {
        DEBUG: if (logName)
            console.debug(`${logName} scrollTo`, { index });
        await claim(min(limit(), 1 + index + policyPreload));
        let stub = stubs[index];
        if (!stub) {
            const stubCount = sizeOfArray(stubs);
            if (!stubCount) {
                DEBUG: console.warn(`${logName} scrollTo #${index} - no items - scroll to container`);
                root.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
                return;
            }
            // TODO maybe use popup context
            DEBUG: console.warn(`${logName} scrollTo #${index} - target not reached, use last item`);
            stub = stubs[sizeOfArray(stubs) - 1];
        }
        DEBUG: if (logName)
            console.debug(`${logName} scrollTo`, { stub });
        stub.scrollIntoView({ behavior: "instant", block: "center", inline: "center" });
    };
    // TODO scroll-control
    const onpopstate = () => {
        const scrollPos = history.state?.[historyKey];
        if (!scrollPos || scrollPos === previousScrollTarget) {
            return;
        }
        previousScrollTarget = scrollPos;
        if (scrollPos >= limit()) {
            // TODO
            console.error(`${logName} onpopstate - scroll position out of range - scroll to tail item`);
            scrollTo(limit() - 1);
            return;
        }
        DEBUG: if (logName)
            console.debug(`${logName} onpopstate - restore scroll position`, { scrollPos });
        scrollTo(scrollPos);
    };
    return {
        connect,
        disconnect: stop,
        enableDebug: (debugName) => {
            logName = `${moduleName}:${debugName}`;
        },
        enableHistory: (historyName) => {
            historyKey = `${moduleName}:${historyName}`;
            enableHistory = true;
            enableCenterProbe = true;
        },
    };
}
